import { PortfolioIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

export const APP_CONFIG_SAVED_LISTS: AppConfig = {
  name: 'Saved Lists',
  applicationKey: 'saved-lists',
  type: 'product',
  appSlugForEngagement: AppSlugs.SavedLists,
  rootPath: '/saved-lists',
  Icon: PortfolioIcon,
  descriptionLong:
    'Create and manage saved property lists and get notified about data changes.',
  descriptionShort:
    'Create and manage saved property lists and get notified about data changes.',
};

export enum VIEW_PATHS_SAVED_LISTS {
  SAVED_LIST = 'saved-list/:savedListId',
  PORTFOLIO = 'portfolio/:portfolioId',
  PORTFOLIO_DOWNLOAD = 'portfolio/:portfolioId/download/:s3Identifier',
  NEW_SAVED_LIST = 'new-saved-list',
  NEW_PORTFOLIO = 'new-portfolio',
  NEW_PORTFOLIO_SETUP = 'new-portfolio/portfolio-setup',
  NEW_PORTFOLIO_UPLOAD = 'new-portfolio/upload',
}
